export default {
  velt: {
    openPanel: 'Kommentarfenster öffnen',
    closePanel: 'Kommentarfenster schließen',
    panel: 'Kommentarfenster',
    tabs: 'Registerkarten des Kommentarfensters',
    comments: 'Kommentare',
    settings: 'Einstellungen & Berechtigungen',
    dragOrTapComment: 'Ziehen, um einen Kommentar hinzuzufügen, oder tippen, um Kommentare anzuzeigen',
    assignComment: 'Kommentar zuweisen',
    markAsUnread: 'Als ungelesen markieren',
    markAsRead: 'Als gelesen markieren',
    unsubscribe: 'Abbestellen',
    subscribe: 'Abonnieren',
    deleteThread: 'Thread löschen',
    editComment: 'Kommentar bearbeiten',
    emptyPlaceholder: 'Geben Sie Feedback, stellen Sie eine Frage oder hinterlassen Sie eine Notiz für Ihre Teammitglieder',
    searchPlaceholder: 'Kommentare suchen',
    commentPlaceholder: 'Kommentar zu {page}',
    replyPlaceholder: 'Antworten....',
    filterPages: 'Seiten',
    filterAuthor: 'Autor',
    filterTagged: 'Markiert',
    statusOpen: 'Offen',
    statusResolved: 'Gelöst',
    anonymous: 'Anonym',
    settingsPanel: {
      title: 'Wer darf kommentieren?',
      everyoneLabel: 'Alle',
      restrictedLabel: 'Nur eingeladene Mitarbeitende',
      emailsLabel: 'E-Mails',
      emailsPlaceholder: 'E-Mail hinzufügen und Enter drücken',
    },
  },
}
